export default {
    topics: [
        {
            title: ' BuildFromCube ',
            href: 'sm-group-BuildFromCube.html',
            attributes: { 'data-id': 'sm-group-BuildFromCube' },
            menu: { hasChildren: false },
            tocID: 'sm-group-BuildFromCube-d66e2965',
            topics: [],
        },
        {
            title: ' Cleanup ',
            href: 'sm-group-Cleanup.html',
            attributes: { 'data-id': 'sm-group-Cleanup' },
            menu: { hasChildren: false },
            tocID: 'sm-group-Cleanup-d66e2973',
            topics: [],
        },
        {
            title: ' ImportFile ',
            href: 'sm-group-ImportFile.html',
            attributes: { 'data-id': 'sm-group-ImportFile' },
            menu: { hasChildren: false },
            tocID: 'sm-group-ImportFile-d66e2981',
            topics: [],
        },
        {
            title: ' Register ',
            href: 'sm-group-Register.html',
            attributes: { 'data-id': 'sm-group-Register' },
            menu: { hasChildren: false },
            tocID: 'sm-group-Register-d66e2989',
            topics: [],
        },
        {
            title: ' Unregister ',
            href: 'sm-group-Unregister.html',
            attributes: { 'data-id': 'sm-group-Unregister' },
            menu: { hasChildren: false },
            tocID: 'sm-group-Unregister-d66e2997',
            topics: [],
        },
        {
            title: ' createAudienceMapping ',
            href: 'sm-group-createAudienceMapping.html',
            attributes: { 'data-id': 'sm-group-createAudienceMapping' },
            menu: { hasChildren: false },
            tocID: 'sm-group-createAudienceMapping-d66e3005',
            topics: [],
        },
        {
            title: ' deleteAudienceMapping ',
            href: 'sm-group-deleteAudienceMapping.html',
            attributes: { 'data-id': 'sm-group-deleteAudienceMapping' },
            menu: { hasChildren: false },
            tocID: 'sm-group-deleteAudienceMapping-d66e3013',
            topics: [],
        },
    ],
};

